import styled from 'styled-components';

export const SpinnerWrapper = styled.div`
  display: flex;
  height: 200px;
  width: 400px;
  align-items: center;
  justify-content: center;
`;
